import {ContentAccessType} from "../../Models/Enums/ContentAccessType";
import {ContentType} from "../../Models/Enums/ContentType";
import ICarouselContentDTO from "../../Models/DTOs/ICarouselContentDTO";

export function createPlaceholderICarouselContentDTO(count: number): ICarouselContentDTO[] {
    return Array.from({ length: count }, (_, i) => ({
        Id: i,
        Title: "Loading...",
        Text: "",
        Season: 0,
        Episode: 0,
        CategoryId: 0,
        Thumbnail: "",
        PortraitThumbnail: "",
        BackgroundImage: "",
        AccessType: ContentAccessType.Unlimited,
        ContentType: ContentType.Film,
        Created: "",
        ReleaseDate: "",
        ReleaseDateEarlyAccess: "",
        IsOriginal: false,
        IsFreeView: false,
        IsFreeViewApp: false,
        IsVisible: true,
        IsFavourite: false,
        Rating: 0,
        IsBookable: false,
        IsClickeable: false,
        LatestEpisode: undefined,
        VideoLinkHLS: "",
        VideoLinkDash: "",
        TrailerLinkHLS: "",
        TrailerLinkDash: "",
        Link: "#", // Fallback link during loading
        OptionalLabel: '',
    }));
}
